// Focus first input
// Takes the result of the desired fieldset step and finds the first
// input. If an input is found it gets focused to help users, in
// particular users using assistive devices.
// ----------------------------------------------------------------

import $ from 'jquery';

export function focusFirstFieldsetInput(step) {
    if ($('fieldset[data-donation-form-step="' + step + '"]').find('input')[0]) {
        $('fieldset[data-donation-form-step="' + step + '"]').find('input')[0].focus();
    }
}
